import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {QuoteService} from '../../shared/quote.service';
import {QuoteRow} from '../../interfaces/quote';

/** The quotes made for this organisation (#1698), newest first; each number opens the editor. */
@Component({
    selector: 'bst-client-quotes-section',
    templateUrl: './client-quotes-section.component.html',
    standalone: false,
})
export class ClientQuotesSectionComponent implements OnChanges {

    @Input({required: true}) clientId: number;

    public quotes: QuoteRow[] = [];
    private loads = 0;

    constructor(private quoteService: QuoteService) {}

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (!changes['clientId']) { return; }
        const load = ++this.loads;
        const quotes = await this.quoteService.forClient(this.clientId).catch(() => []);
        // Another organisation opened meanwhile: this answer is stale.
        if (this.loads === load) { this.quotes = quotes; }
    }
}
